import cache from './cache.js';
import getUserAgent from './getUserAgent.js';
import regex from './isBlackberry.json';

export default cache('isBlackberry', function isBlackberry() {
  const pattern = new RegExp(...regex);
  return pattern.test(getUserAgent());
});